import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { CreateGuidelineDto, GuidelineType } from "shared";
import { Api } from "../api.config";

const QUERY_KEY = ["guidelines"] as const;

export function useGuidelines() {
	return useQuery({
		queryKey: QUERY_KEY,
		queryFn: async () => {
			const { data } = await Api.GetGuidelines();
			return data;
		},
	});
}

export function useGuidelinesActions() {
	const queryClient = useQueryClient();

	const create = useMutation({
		mutationFn: async (dto: CreateGuidelineDto) => {
			const { data } = await Api.CreateGuideline(dto);
			return data;
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: QUERY_KEY });
		},
	});

	const remove = useMutation({
		mutationFn: async (id: number) => {
			await Api.DeleteGuideline(id);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: QUERY_KEY });
		},
	});

	const uploadDocument = useMutation({
		mutationFn: async ({ type, file }: { type: GuidelineType; file: File }) => {
			const { data } = await Api.UploadGuidelineDocument(type, file);
			return data;
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: QUERY_KEY });
		},
	});

	return { create, remove, uploadDocument };
}
